import { Toast } from "@newsela/angelou";

import globalToasterRef from "@/base/globalToasterRef";
import EnvelopeIcon from "@/icons/EnvelopeIcon";
import FacebookIcon from "@/icons/FacebookIcon";
import GoogleClassroomIcon from "@/icons/GoogleClassroomIcon";
import LinkIcon from "@/icons/LinkIcon";
import PinterestIcon from "@/icons/PinterestIcon";
import RemindIcon from "@/icons/RemindIcon";
import TwitterIcon from "@/icons/TwitterIcon";
import getContentLabel from "@/utils/getContentLabel";
import addTrackingUrchinsToUrl from "@/view/utils/addTrackingUrchinsToUrl";
import copyTextToClipboard from "@/view/utils/copyTextToClipboard";
import getGoogleShareUrl from "./utils";
import {
  envelopeIconCss,
  facebookIconCss,
  googleClassroomIconCss,
  linkIconCss,
  pinterestIconCss,
  remindIconCss,
} from "./ShareOptions.style";

export const shareOptionsConfig = (
  socialShareUrl,
  title,
  thumbnail,
  contentType,
) => {
  return [
    {
      name: "Google Classroom",
      description: "Google Classroom Content",
      icon: <GoogleClassroomIcon css={googleClassroomIconCss} />,
      href: getGoogleShareUrl(),
    },
    {
      name: "Copy link",
      description: `Copy ${contentType} Link`,
      icon: <LinkIcon css={linkIconCss} />,
      onClick: async () => {
        await copyTextToClipboard(socialShareUrl);
        globalToasterRef.current.displayToast({
          statusColor: Toast.statusColor.success,
          children: `${getContentLabel({ content_type: contentType })} Copied`,
        });
      },
    },
    {
      name: "Facebook",
      description: "Facebook Share",
      icon: <FacebookIcon css={facebookIconCss} />,
      params: {
        app_id: 800029800066261,
        link: addTrackingUrchinsToUrl(socialShareUrl, "facebook"),
        redirectUri: socialShareUrl,
      },
      baseShareUrl: "https://www.facebook.com/dialog/feed?",
    },
    {
      name: "Email",
      description: "Email Share",
      icon: <EnvelopeIcon css={envelopeIconCss} />,
      onClick: () => {
        const subject = `Check Out This ${contentType}`;
        const body = `I just found this ${contentType.toLowerCase()}, ${title} ${socialShareUrl}`;
        window.location = `mailto:?subject=${subject}&body=${body}`;
      },
    },
    {
      name: "Twitter",
      description: "Twitter Share",
      icon: <TwitterIcon />,
      params: {
        url: addTrackingUrchinsToUrl(socialShareUrl, "twitter"),
        text: `Newsela | ${title || `Check out this Newsela ${contentType}`}`,
      },
      baseShareUrl: "https://twitter.com/share?",
    },
    {
      name: "Pinterest",
      description: "Pinterest Share",
      icon: <PinterestIcon css={pinterestIconCss} />,
      params: {
        url: addTrackingUrchinsToUrl(socialShareUrl, "pinterest"),
        media: thumbnail || "",
        description: title,
      },
      baseShareUrl: "https://pinterest.com/pin/create/button/?",
    },
    {
      name: "Remind",
      description: "Remind Share",
      icon: <RemindIcon css={remindIconCss} />,
      params: {
        url: addTrackingUrchinsToUrl(socialShareUrl, "remind"),
        referrer: socialShareUrl,
      },
      baseShareUrl: "https://www.remind.com/v1/share?",
    },
  ];
};
